import { css } from 'styled-components';

export const textMixin = css`
	font-weight: 400;
	font-size: 16px;
`;